import { render, staticRenderFns } from "./labelDatabase.vue?vue&type=template&id=1c4fb508&scoped=true&"
import script from "./labelDatabase.vue?vue&type=script&lang=js&"
export * from "./labelDatabase.vue?vue&type=script&lang=js&"
import style0 from "./labelDatabase.vue?vue&type=style&index=0&id=1c4fb508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fb508",
  null
  
)

component.options.__file = "labelDatabase.vue"
export default component.exports